import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/@ant-design+nextjs-registry@1.0.1_@ant-design+cssinjs@1.21.1_react-dom@18.3.1_react@18.3.1__r_t3zepllpp3x2vo5aur4uo5gtcu/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.13_@babel+core@7.25.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DynamicFavicon.tsx");
